import { addChatResponse, setChatOutageMessage, updateChat, updateChatTitle } from 'actions/supportAssistant/supportAssistantActions'
import useSocketEvent from './useSocketEvent'
import { useAppDispatch } from 'hooks/reduxHooks'
import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { mapChat } from 'api/mappers/supportAssistant/supportAssistant'
import type { Chat } from '@luxuryescapes/contract-support'

function useChatListener() {
  const dispatch = useAppDispatch()
  const intl = useIntl()

  const onMessageResponse = useCallback((message: App.ChatMessage, callback?: (_response: { ok: boolean; id: string, duplicate: boolean }) => void) => {
    dispatch(addChatResponse(message, callback))
  }, [dispatch])

  const onChatTitleResponse = useCallback((chatTitle: App.ChatTitle) => {
    dispatch(updateChatTitle(chatTitle))
  }, [dispatch])

  const onChatUpdateResponse = useCallback((chat: Chat) => {
    dispatch(updateChat(mapChat(chat)))
  }, [dispatch])

  const onChatErrorServiceResponse = useCallback((error: App.ChatError) => {
    dispatch(setChatOutageMessage(error.text))
  }, [dispatch])

  // Previsouly, we just handled this error state by displaying a message
  // TODO: We need to investigate if there is a better way to handle this error state.
  const onChatErrorResponse = useCallback(() => {
    showSnackbar(
      intl.formatMessage({
        id: 'Z0wWgJHfAO',
        defaultMessage: 'Something went wrong, please try again later.',
        description: 'Error snackbar message when chat encounters an error',
      }),
      'critical',
      {
        heading: intl.formatMessage({
          id: 'R/31t1rwmF',
          defaultMessage: 'Error',
          description: 'Error snackbar heading for chat error',
        }),
      },
    )
  }, [intl])

  useSocketEvent('message:response', onMessageResponse)
  useSocketEvent('chat:title-set', onChatTitleResponse)
  useSocketEvent('chat:update', onChatUpdateResponse)

  useSocketEvent('chat:error:service', onChatErrorServiceResponse)
  useSocketEvent('chat:error', onChatErrorResponse)
}

export default useChatListener
